import React from 'react';
import Input from './Input';
import Select,{Creatable as CreatableSelect} from 'react-select';
import 'react-select/dist/react-select.css';
import './InputSelect.scss';

export default class InputSelect extends React.Component {
  render() {
    return (
        <Input {...this.props} className="ComponentInputSelect">
          <div className="field-wrap">
            {this.props.creatable ?(<CreatableSelect {...this.props}/>) : (<Select {...this.props}/>)}
          </div>
        </Input>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InputSelect.js